<template>
  <ChapterComponent class="chapter--header-right" :opened="opened" :number="4" illustration="4/1.jpg">
    <div class="chapter__header-texts" slot="header_texts">
      <div class="chapter__number">IV</div>
      <div class="chapter__author">Автор Тихон Шаров</div>
      <div class="chapter__headline">Миссия выполнима</div>
      <div class="chapter__inner">
        <div class="chapter__description">
          <div class="chapter__description__inner">
           Неужели в сверхскоростной век стартапов, нанотехнологий и микроблогов можно поверить в существование Купидона? Да и кому нужен в глубоко прагматичной современной реальности шаловливый ангел, стреляющий волшебными<span class="chapter__description__not-opened-text">...</span><span class="chapter__description__opened-text"> стрелами в еще не тронутые истинной любовью сердца? Тоскующие по ласке и взаимопониманию горожане регистрируются на сайтах знакомств, ищут своих половинок на шумных вечеринках и в офисной суете… А кто-то полагается на судьбу и ждет, когда Настоящее Чувство само нахлынет из ниоткуда девятым валом страстей. Правда, ожидание это может длиться невыносимо долго...</span>
         </div>
        </div>
        <div class="chapter__mobile-illustration" :style="{backgroundImage: `url(${require(`../../assets/illustrations/4/1.jpg`)})`}"></div>
        <div class="chapter__buttons">
          <a class="button" v-if="!opened" @click="opened = true" v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'open_chapter_4')">Открыть главу</a>
          <div v-else class="chapter__read-more">
            <div class="chapter__read-more__text">Читать далее</div>
            <svg  class="chapter__read-more__arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 110.2" style="enable-background:new 0 0 26 110.2;" xml:space="preserve">>
              <path class="st0" d="M21.9,65c-2,5-4,10.1-6,15.1C15,55.7,14.2,31.2,13.4,6.8c0-1.2-4.7-0.8-4.6,0.5c0.8,26.5,1.7,53,2.7,79.6 c-2-5.3-4.1-10.7-6.1-16c-0.5-1.3-5-0.5-4.6,0.5L12,102.1c0.4,1,3.3,0.9,4.3,0.1c0.3-0.2,0.6-0.4,0.7-0.6 c3.2-12.2,6.3-24.4,9.5-36.6C26.8,63.6,22.3,63.9,21.9,65"/>
            </svg>
          </div>
          <Listen :chapter="4" :opened="opened" />
        </div>
      </div>
    </div>
    <div slot="main" class="chapter__main" v-if="opened">
      <div class="chapter__texts">
        <Paragraph class="chapter__paragraph chapter__paragraph--1">
          <div class="person">
            <div class="person__inner">
              <img class="person__photo" src="@/assets/illustrations/4/photo.png"/>
              <div class="person__name">Тимур Касаткин</div>
              <div class="person__age">29 лет</div>
              <div class="person__info">
                Арт-директор рекламного агентства
              </div>
              <div class="person__location">
                Корпус Andante, 6-й этаж
              </div>
              <MapToggle/>
            </div>
          </div>
          <p>И все же бог любви, также известный как Эрос и Амур, очутился в нашем бренном мире. Какие ветры из параллельной вселенной занесли его в один из корпусов нового жилищного комплекса в центре Москвы, нам неизвестно. Но факт остается фактом — однажды вечером озадаченный Купидон материализовался в роскошном лобби, прямо над стойкой ресепшен. Оглядевшись, невидимый человеческому глазу проказник понял, что выбор жертв невелик. В двух метрах под ним светловолосая девушка-администратор мечтательно смотрела в монитор, подперев голову рукой. Смена только началась, впереди была долгая ночь, и провести ее Ангелине предстояло наедине со своим богатым внутренним миром и заветными переживаниями. Купидон сразу же почувствовал тихую дрожь влечения, исходившую от молодого сердца, и, практически не целясь, выпустил первую стрелу. Ангелина глубоко вздохнула и поправила прическу, а меткий ангелок потер пухлые ручки — осталось поразить второе, бьющееся в унисон сердце, владелец которого был уже рядом. Но вот беда: когда силуэт высокого молодого человека в строгом костюме возник за стеклом вращающихся дверей, космические вихри подхватили посланца небес и унесли куда-то далеко-далеко…</p>
          <Listen :chapter="4" class="listen--mobile-only" />
          <p>В лобби вошел топ-менеджер Максим, завидный жених и кумир десятков светских львиц — тот самый жилец, при виде которого голубые глаза Ангелины неизменно загорались неземным огнем. Как обычно, он отреагировал на ее звонкое приветствие мрачным кивком, бросил взгляд исподлобья и поспешил к лифтам. В очередной раз скромная девушка удивилась собственной наивности: ну какое дело этому принцу из пентхауса до серой мышки, приехавшей из провинции? Когда через несколько минут мимо стойки прошел <router-link @click.native="$ga.event('internal','click', 'open_chapter_7')" to="/chapters/7" class="chapter__link">симпатичный мужчина из 64-й квартиры в своей обычной кожаной куртке</router-link>, он сразу заметил тень обиды на лице Ангелины и деликатно поинтересовался, все ли в порядке. А ей лишь оставалось кивать и улыбаться, сдерживая горькие слезы…</p>
        </Paragraph>
        <Paragraph class="chapter__paragraph chapter__paragraph--2">
          <p>Девушка не могла и подумать, что именно ради нее Максим регулярно проделывал бессмысленный крюк через лобби, вместо того чтобы спокойно подняться к себе на отдельном лифте из подземного паркинга. В присутствии улыбчивой красавицы жесткого бизнесмена охватывала сладкая тоска, смешанная с невыносимой робостью. Какая-то странная сила мешала ему заговорить с ней, пригласить в ресторан… Все-таки человеческие эмоции остаются для нас самой большой загадкой… Неделю спустя Максим наконец решился открыть душу фее с ресепшен, но в лобби дежурила другая девушка — не менее привлекательная брюнетка. Увы, Ангелина поняла, что надеждам ее сбыться не суждено, и уволилась по собственному желанию.</p>
          <p>Так бы и закончилась эта история, как миллионы других грустных историй большого города, если бы ответственный Купидон не вернулся из Эмпирея на землю, чтобы все исправить. Крылатый сердцевед понял, что тратить еще одну стрелу на Максима нет смысла — достаточно оставить на письменном столике записку с телефоном Ангелины и словами: «Будь мужчиной! Позвони ей и скажи все, что чувствуешь». Не так романтично, как в старые времена, зато эффективно.</p>
        </Paragraph>
      </div>
      <div class="plan">
        <div class="plan__header">
          Место встречи
        </div>
        <div class="plan__main">
          <div class="plan__background"></div>
          <img src="@/assets/illustrations/4/2.jpg" class="plan__photo"/>
          <div class="plan__description">
            <div class="plan__description__text">Каждый подъезд в каждом из корпусов «Фили Сити» начинается с прекрасно продуманного и оборудованного лобби. Просторные холлы отличаются оригинальным дизайном и включают в себя ресепшен, места для колясок и велосипедов, удобные красивые лифты. Идеальнее места для конференц-колла невозможно придумать.</div>
            <a target="_blank" href="https://filicity.ru/?utm_source=article&utm_campaign=june19&utm_medium=banner&utm_content=4" class="button"  v-ga.click="$ga.commands.click.bind(this,'external', 'click', 'chapter_4_podrobnee')">Подробнее</a>
          </div>
        </div>
      </div>
      <div class="chapter__next">
        <div class="chapter__number">V</div>
        <div class="chapter__headline">Завтра в три</div>
        <div class="chapter__next__button">
          <router-link class="button" to="/chapters/5"   v-ga.click="$ga.commands.click.bind(this,'internal', 'click', 'bottom_open_chapter_5')">Открыть главу</router-link>
        </div>
      </div>
    </div>
  </ChapterComponent>
</template>
<style lang="stylus" scoped>
  @import "~@/assets/styles/sizes.styl";
  .chapter
    &__next
      padding vw(60, $desktop) 0 vw(80, $desktop)
    &__paragraph
      &--1
        padding-top vw(40, $desktop)
        margin-left vw(200, $desktop)
        width vw(500, $desktop)
        margin-bottom vw(70, $desktop)
        .person
          top vw(-30, $desktop)
          right vw(-270, $desktop)
          align-items flex-end
          &__photo
            width vw(110, $desktop)
      &--2
        margin-left auto
        margin-right vw(160, $desktop)
        width vw(560, $desktop)
        margin-top vw(120, $desktop)
        margin-bottom vw(70, $desktop)
  .plan__description
    top vw(180, $desktop)
  .plan__mrgroup-logo
    bottom 0
    left: vw(50, $desktop)
    position: absolute;
    img
      height vw(20, $desktop)
      +mobile()
        height: vw(20, $mobile)
    +mobile()
        bottom: vw(-30, $mobile)
        left: vw(20, $mobile)
</style>
<script>
    import ChapterComponent from '@/components/ChapterComponent';
    import Paragraph from '@/components/Paragraph';
    import Listen from '@/components/Listen';
    import MapToggle from '@/components/MapToggle';
    export default {
        components: {
            Paragraph,
            Listen,
            MapToggle,
            ChapterComponent
        },
        data() {
          return {
              opened: !!this.$route.query.opened || false
          }
      }
  }
</script>